/**
 * Product CrossFrame Listeners
 *
 * Handles CrossFrame requests for product operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetProductInfoInput } from '@amzn/coral_com-amazon-ihmvirgo-coral/GetProductInfoInput'
import { ProductInfo } from '@amzn/coral_com-amazon-ihmvirgo-coral/ProductInfo'
import { validateRequired } from './listenerUtils'

export async function getProductInfoListener (message: any): Promise<ProductInfo> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId', 'itemId', 'itemIdType')
    const client = getServiceClient()
    return client.getProductInfo(GetProductInfoInput.clone(params)).toPromise()
}
